import React, { useState } from 'react';

const brandLogos = {
  ChargeNest: 'https://media-manager-c.questera.ai/greta-media/b64cc446cdd47675bdad19de596fda49c979fcc46f742bafa38ab384e40234c3cc3101a26c56d32c5dccb06920b38db8/images/aW1hZ2UvcG5n/29600e09bdecda10c6f2db2f15e79492.png'
};

const getLogoSources = (link) => [
  brandLogos[link.name],
  `https://${link.domain}/apple-touch-icon.png`,
  `https://${link.domain}/favicon.ico`,
  `https://www.google.com/s2/favicons?domain_url=https://${link.domain}&sz=128`,
  `https://icons.duckduckgo.com/ip3/${link.domain}.ico`
].filter(Boolean);

const NetworkMark = ({ link }) => {
  const logoSources = getLogoSources(link);
  const [sourceIndex, setSourceIndex] = useState(0);
  const hasLogoSource = sourceIndex < logoSources.length;

  const handleImageError = () => {
    setSourceIndex((currentIndex) => currentIndex + 1);
  };

  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative flex items-center gap-3 px-3.5 py-2 rounded-full border border-white/15 bg-white/[0.03] hover:bg-white/[0.08] hover:border-white/40 transition-all duration-300 backdrop-blur-sm"
      title={`${link.name} – ${link.domain}`}
      aria-label={`${link.name} in einem neuen Tab öffnen`}
    >
      <div className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center overflow-hidden p-1 transition-transform duration-300 group-hover:scale-110">
        {hasLogoSource ? (
          <img
            src={logoSources[sourceIndex]}
            alt={`${link.name} Logo`}
            className="w-full h-full object-contain transition-all duration-300"
            onError={handleImageError}
            loading="lazy"
            referrerPolicy="no-referrer"
          />
        ) : (
          <span className="text-[10px] font-bold text-white uppercase">
            {link.name.slice(0, 2)}
          </span>
        )}
      </div>

      <span className="text-xs font-medium text-gray-300 group-hover:text-white transition-colors pr-1">
        {link.name}
      </span>
    </a>
  );
};

export default NetworkMark;